export default "__VITE_ASSET__acaa2768__"